module.exports = __webpack_public_path__ + "static/img/banner4.45e35bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_recruitment/banner4.png
// module id = 8ona
// module chunks = 1